import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Subject } from 'rxjs';
import { JoyrideScroll } from '../joyride.domain';

@Injectable({ providedIn: 'root' })
export class JoyrideEventListenerService {
  scrollEvent: Subject<JoyrideScroll> = new Subject<JoyrideScroll>();
  resizeEvent: Subject<number> = new Subject<number>();

  private renderer: Renderer2;
  private scrollUnlisten: () => void;
  private resizeUnlisten: () => void;

  constructor(@Inject('window') private browserWindow: Window, private readonly rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  startListeningScrollEvents(): void {
    this.scrollUnlisten = this.renderer.listen('document', 'scroll', () => {
      this.scrollEvent.next({
        scrollX: this.browserWindow.pageXOffset,
        scrollY: this.browserWindow.pageYOffset
      });
    });
  }

  startListeningResizeEvents(): void {
    this.resizeUnlisten = this.renderer.listen('window', 'resize', (size: number) => {
      this.resizeEvent.next(size);
    });
  }

  stopListeningScrollEvents(): void {
    this.scrollUnlisten();
  }

  stopListeningResizeEvents(): void {
    this.resizeUnlisten();
  }
}
